import { getDefaultAgentMatcherPolicyUrl } from './getDefaultAgentMatcherPolicyUrl.mjs';

//
/** @hidden */
function getDefaultAgentMatcherPolicyMatcherUrl(resource, name, mode) {
    return getDefaultAgentMatcherPolicyUrl(resource, name, mode).concat("Matcher");
}

export { getDefaultAgentMatcherPolicyMatcherUrl };
